// Customizable Area Start
import React, { Component } from "react";
import { Box, IconButton, Typography, styled } from "@mui/material";
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import MessageBubbleComponent from "./MessageBubbleComponent.web";

type Props = {
  fileUrl: string;
  fileName: string;
  fileExtension: string
  time: string;
  date: string;
  senderId: string;
  loggedInUserId: string;
  isSeen: boolean;
};

const FileBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "8px 12px",
  borderRadius: "8px",
  backgroundColor: "#F1F5F9",
  width: "100%",
  maxWidth: "288px",
  overflow: "hidden",
});

const FileIcon = styled(InsertDriveFileRoundedIcon)({
  color: "#652784",
});

const FileName = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  color: "#0F172A",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const FileType = styled(Typography)({
  fontSize: "12px",
  color: "#64748B",
  marginRight: "12px",
});

const DownloadButton = styled(IconButton)({
  padding: "6px",
  color: "#652784",
});

const FileInfoWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "2px",
  minWidth: 0,
  flex: 1,
});

class FileMessage extends Component<Props> {

  handleDownload = () => {
    const link = document.createElement("a");
    link.href = this.props.fileUrl;
    link.download = "";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    const { time, date, senderId, loggedInUserId, isSeen, fileExtension, fileName } = this.props;

    return (
      <MessageBubbleComponent
        senderId={senderId}
        loggedInUserId={loggedInUserId}
        time={time}
        date={date}
        isSeen={isSeen}
      >
        <FileBox>
          <FileIcon />
          <FileInfoWrapper>
            <FileName title={fileName}>{fileName}</FileName>
            <FileType>{fileExtension.toUpperCase()}</FileType>
          </FileInfoWrapper>
          <DownloadButton onClick={this.handleDownload}>
            <DownloadRoundedIcon />
          </DownloadButton>
        </FileBox>
      </MessageBubbleComponent>
    );
  }
}

export default FileMessage;
// Customizable Area End
